import { useMemo } from 'react';
import { useAppSelector } from '@/store';

/**
 * Checks if PMS integration is enabled for maintenance/payment features.
 * Returns true when the property's PMS is Yardi and the
 * 'yardi-integration-disabled' kill switch is not set.
 */
export const usePmsIntegrationEnabled = (): boolean => {
  const user = useAppSelector((s) => s.auth.user as any);

  return useMemo(() => {
    try {
      const pmsType = user?.property?.pmsType;
      if (pmsType !== 'yardi') {
        return false;
      }

      const flags = user?.property?.featureFlags?.flags || {};
      if (typeof flags['yardi-integration-disabled'] === 'boolean') {
        return !flags['yardi-integration-disabled'];
      }

      return true;
    } catch (error) {
      // If feature flag lookup fails, default to disabled
      return false;
    }
  }, [user]);
};

